var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNoUsers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 24c6.628 0 12-5.373 12-12S27.628 0 21 0 9 5.373 9 12s5.372 12 12 12Zm4.753 4.5h-9.506C7.272 28.5 0 35.775 0 44.747A3.25 3.25 0 0 0 3.25 48h35.497c1.8 0 3.253-1.453 3.253-3.253C42 35.775 34.725 28.5 25.753 28.5Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M44.916 30h-6.924C42.3 33.534 45 38.822 45 44.747c0 1.2-.356 2.306-.937 3.253H57c1.66 0 3-1.35 3-3.084C60 36.713 53.288 30 44.916 30ZM40.5 24C46.303 24 51 19.303 51 13.5S46.303 3 40.5 3c-2.354 0-4.504.802-6.255 2.11C35.325 7.184 36 9.506 36 12c0 3.33-1.118 6.388-2.961 8.88A10.466 10.466 0 0 0 40.5 24Z",
    fill: "url(#c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 46.519,
    y1: 3,
    x2: 46.519,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v48H0z"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNoUsers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-users.c57dcd82b70240e196a76d5adc2c3f10.svg";